export const metrics = {
  width: 960,
  height: 480,
  aspectRatio: 2, // 2:1 - change this for small portrait devices?
  dateRange: 460, // should match witdth of .dateRange
  filterWidth: 224,
  chartHeight: 172,
  baseScale: 1070,
  padding: 16,
  barSize: 12,
  denom: 3, // denom: 3.239, // 33
  scale: {
    min: 1,
    max: 20,
  },
  levelLine: 3,
  levels: [
    'state',
    'city',
  ],
};

export const colors = {
  grey: {
    lightest: '#ededed',
    light: '#c8c8c6',
    dark: '#8c8c8a',
    darkest: '#333333',
  },
  yellow: {
    light: '#f1c586',
    dark: '#cda872',
  },
  // pink: {
  //   light: '#e26be1',
  //   dark: '#c05bbf',
  // },
  // green: {
  //   light: '#02b092',
  //   dark: '#02967c',
  // },
  redA: {
    light: '#9c3022',
    dark: '#85291d',
  },
  // redB: {
  //   light: '#d61212',
  //   dark: '#b60f0f',
  // },
  blueA: {
    light: '#0cb7e1',
    dark: '#0a9cbf',
  },
  blueB: {
    light: '#087dff',
    dark: '#076ad9',
  },
};

/*
  to get an updated rotation matrix use
  getMatrixTransform(zDegreeRotation, xDegreeRotation)
  from ./getMatrixTransform.js
*/
export const rotations = {
  west: {
    matrix: `
            0.838670567945424 -0.2723195175075136
            0.5446390350150271 0.41933528397271214
            0 -0.8660254037844386
            `,
    x: 60,
    y: 0,
    z: -33, //-30 //-29,
    bg: {
      x: -4,
      y: 4,
    },
  },
  east: {
    x: 60,
    y: 0,
    z: 45,
    bg: {
      x: 4,
      y: 4,
    },
  },
};

const sections = {
  'banner-Public': {
    order: 0,
    gradient: 'url(#yellow)',
    color: colors.yellow.light,
  },
  'flier-Campus': {
    order: 1,
    gradient: 'url(#blueA)',
    color: colors.blueA.light,
  },
  'flier-Public': {
    order: 2,
    gradient: 'url(#redA)',
    color: colors.redA.light,
  },
  // 'Identity Evropa': {
  //   order: 3,
  //   gradient: 'url(#green)',
  //   color: colors.green.light,
  // },
  // 'American Identity Movement/Identity Evropa': {
  //   order: 3,
  //   gradient: 'url(#green)',
  //   color: colors.green.light,
  // },
  // 'New Jersey European Heritage Assoc.': {
  //   order: 3,
  //   gradient: 'url(#green)',
  //   color: colors.green.light,
  // },
  // 'Patriot Front': {
  //   order: 2,
  //   gradient: 'url(#pink)',
  //   color: colors.pink.light,
  // },
  // 'Ku Klux Klan': {
  //   order: 1,
  //   gradient: 'url(#redB)',
  //   color: colors.redB.light,
  // },
  'Other': {
    order: 0,
    gradient: 'url(#blueB)',
    color: colors.blueB.light,
  },
};

export const sectionsByGrouping = {
  Type: ['flier-Public', 'flier-Campus', 'banner-Public'],
  // Group: ['New Jersey European Heritage Assoc.', 'Patriot Front', 'Ku Klux Klan', 'Other'],
  Group: ['Other'],
  // Group: ['Identity Evropa', 'New Jersey European Heritage Assoc.', 'Patriot Front', 'Ku Klux Klan', 'Other'],
}

export function addGroups(groups) {
  const groupNames = groups.map(d => d.Group)
  sectionsByGrouping.Group.unshift(...groupNames)
  groups.forEach(({Group, Color1, Color2}, index) => {
    const groupKey = `group${index}`
    colors[groupKey] = {
      light: Color1,
      dark: Color2,
    }
    sections[Group] = {
      order: groups.length - index,
      gradient: `url(#${groupKey})`,
      color: colors[groupKey].light,
    }
  })
}

const typeMap = {
  'Banners': 'banner-Public',
  'Campus Flyers': 'flier-Campus',
  'Public Flyers': 'flier-Public',
};

export function section(key) {
  if (typeMap.hasOwnProperty(key)) {
    key = typeMap[key];
  }
  if (sections.hasOwnProperty(key)) {
    return sections[key];
  }
  return sections['Other'];
};

/* Some range styles are also defined in App.css */
export const range = {
  rail: {
    height: '1px',
    marginTop: '1px',
    background: '#999'
  },
  track: {
    height: '3px',
    background: '#000000', // replace w/ colors.XYZ
  },
  handle: {
    zIndex: 100,
  },
  marks: {
    left: {
      position: 'absolute',
      color: 'black',
      fontSize: '14px',
      top: 0,
      right: '48%',
      textAlign: 'left',
    },
    right: {
      position: 'absolute',
      color: 'black',
      fontSize: '14px',
      top: 0,
      left: '48%',
      textAlign: 'right',
    },
    january: {
      marginTop: -metrics.padding * 1.875,
      height: '8px',
      overflow: 'hidden',
      fontSize: '16px',
      color: '#999999',
    },
    year: {
      marginTop: -metrics.padding * 2.125,
      color: '#999999',
      fontSize: '14px',
      letterSpacing: '3px',
    },
  },
};

export const locations = {
  'Alabama': { Latitude: 32.806671, Longitude: -86.791130 },
  'Alaska': { Latitude: 61.370716, Longitude: -152.404419 },
  'Arizona': { Latitude: 33.729759, Longitude: -111.431221 },
  'Arkansas': { Latitude: 34.969704, Longitude: -92.373123 },
  'California': { Latitude: 36.116203, Longitude: -119.681564 },
  'Colorado': { Latitude: 39.059811, Longitude: -105.311104 },
  'Connecticut': { Latitude: 41.597782, Longitude: -72.755371 },
  'Delaware': { Latitude: 39.318523, Longitude: -75.507141 },
  'District of Columbia': { Latitude: 38.897438, Longitude: -77.026817 },
  'Florida': { Latitude: 27.766279, Longitude: -81.686783 },
  'Georgia': { Latitude: 33.040619, Longitude: -83.643074 },
  'Hawaii': { Latitude: 21.094318, Longitude: -157.498337 },
  'Idaho': { Latitude: 44.240459, Longitude: -114.478828 },
  'Illinois': { Latitude: 40.349457, Longitude: -88.986137 },
  'Indiana': { Latitude: 39.849426, Longitude: -86.258278 },
  'Iowa': { Latitude: 42.011539, Longitude: -93.210526 },
  'Kansas': { Latitude: 38.526600, Longitude: -96.726486 },
  'Kentucky': { Latitude: 37.747586, Longitude: -84.295478 },
  'Louisiana': { Latitude: 31.169546, Longitude: -91.867805 },
  'Maine': { Latitude: 44.693947, Longitude: -69.381927 },
  'Maryland': { Latitude: 39.407366, Longitude: -76.779873 },
  'Massachusetts': { Latitude: 42.230171, Longitude: -71.530106 },
  'Michigan': { Latitude: 43.326618, Longitude: -84.536095 },
  'Minnesota': { Latitude: 45.694454, Longitude: -93.900192 },
  'Mississippi': { Latitude: 32.741646, Longitude: -89.678696 },
  'Missouri': { Latitude: 38.456085, Longitude: -92.288368 },
  'Montana': { Latitude: 46.921925, Longitude: -110.454353 },
  'Nebraska': { Latitude: 41.125370, Longitude: -98.268082 },
  'Nevada': { Latitude: 38.313515, Longitude: -117.055374 },
  'New Hampshire': { Latitude: 43.452492, Longitude: -71.563896 },
  'New Jersey': { Latitude: 40.089738, Longitude: -74.355922 },
  'New Mexico': { Latitude: 34.840515, Longitude: -106.248482 },
  'New York': { Latitude: 42.081742, Longitude: -74.312072 },
  'North Carolina': { Latitude: 35.630066, Longitude: -79.806419 },
  'North Dakota': { Latitude: 47.528912, Longitude: -99.784012 },
  'Ohio': { Latitude: 40.388783, Longitude: -82.764915 },
  'Oklahoma': { Latitude: 35.565342, Longitude: -96.928917 },
  'Oregon': { Latitude: 44.572021, Longitude: -122.070938 },
  'Pennsylvania': { Latitude: 40.590752, Longitude: -77.209755 },
  'Rhode Island': { Latitude: 41.680893, Longitude: -71.511780 },
  'South Carolina': { Latitude: 33.856892, Longitude: -80.945007 },
  'South Dakota': { Latitude: 44.299782, Longitude: -99.438828 },
  'Tennessee': { Latitude: 35.921469, Longitude: -86.872469 },
  'Texas': { Latitude: 31.054487, Longitude: -97.563461 },
  'Utah': { Latitude: 40.150032, Longitude: -111.862434 },
  'Vermont': { Latitude: 44.045876, Longitude: -72.710686 },
  'Virginia': { Latitude: 37.495103, Longitude: -78.246705 },
  'Washington': { Latitude: 47.400902, Longitude: -121.490494 },
  'West Virginia': { Latitude: 38.491226, Longitude: -80.954453 },
  'Wisconsin': { Latitude: 44.268543, Longitude: -89.616508 },
  'Wyoming': { Latitude: 42.755966, Longitude: -107.302490 },
};

export const capitals = [
  { 'state': 'Alabama', 'name': 'Montgomery', 'Latitude': 32.3792233, 'Longitude': -86.3077368 },
  { 'state': 'Alaska', 'name': 'Juneau', 'Latitude': 58.3019444, 'Longitude': -134.4197221 },
  { 'state': 'Arizona', 'name': 'Phoenix', 'Latitude': 33.4483771, 'Longitude': -112.0740373 },
  { 'state': 'Arkansas', 'name': 'Little Rock', 'Latitude': 34.7464809, 'Longitude': -92.2895948 },
  { 'state': 'California', 'name': 'Sacramento', 'Latitude': 38.5815719, 'Longitude': -121.4943996 },
  { 'state': 'Colorado', 'name': 'Denver', 'Latitude': 39.7392358, 'Longitude': -104.990251 },
  { 'state': 'Connecticut', 'name': 'Hartford', 'Latitude': 41.7658043, 'Longitude': -72.6733723 },
  { 'state': 'Delaware', 'name': 'Dover', 'Latitude': 39.158168, 'Longitude': -75.5243682 },
  { 'state': 'Hawaii', 'name': 'Honolulu', 'Latitude': 21.3069444, 'Longitude': -157.8583333 },
  { 'state': 'Florida', 'name': 'Tallahassee', 'Latitude': 30.4382559, 'Longitude': -84.2807329 },
  { 'state': 'Georgia', 'name': 'Atlanta', 'Latitude': 33.7489954, 'Longitude': -84.3879824 },
  { 'state': 'Idaho', 'name': 'Boise', 'Latitude': 43.6150186, 'Longitude': -116.2023137 },
  { 'state': 'Illinois', 'name': 'Springfield', 'Latitude': 39.7817213, 'Longitude': -89.6501481 },
  { 'state': 'Indiana', 'name': 'Indianapolis', 'Latitude': 39.768403, 'Longitude': -86.158068 },
  { 'state': 'Iowa', 'name': 'Des Moines', 'Latitude': 41.5868353, 'Longitude': -93.6249593 },
  { 'state': 'Kansas', 'name': 'Topeka', 'Latitude': 39.0473451, 'Longitude': -95.6751576 },
  { 'state': 'Kentucky', 'name': 'Frankfort', 'Latitude': 38.2009055, 'Longitude': -84.8732835 },
  { 'state': 'Louisiana', 'name': 'Baton Rouge', 'Latitude': 30.4514677, 'Longitude': -91.1871466 },
  { 'state': 'Maine', 'name': 'Augusta', 'Latitude': 44.3106241, 'Longitude': -69.7794897 },
  { 'state': 'Maryland', 'name': 'Annapolis', 'Latitude': 38.9784453, 'Longitude': -76.4921829 },
  { 'state': 'Massachusetts', 'name': 'Boston', 'Latitude': 42.3600825, 'Longitude': -71.0588801 },
  { 'state': 'Michigan', 'name': 'Lansing', 'Latitude': 42.732535, 'Longitude': -84.5555347 },
  { 'state': 'Minnesota', 'name': 'St. Paul', 'Latitude': 44.9537029, 'Longitude': -93.0899578 },
  { 'state': 'Mississippi', 'name': 'Jackson', 'Latitude': 32.2987573, 'Longitude': -90.1848103 },
  { 'state': 'Missouri', 'name': 'Jefferson City', 'Latitude': 38.5767017, 'Longitude': -92.1735164 },
  { 'state': 'Montana', 'name': 'Helena', 'Latitude': 46.5891452, 'Longitude': -112.0391057 },
  { 'state': 'Nebraska', 'name': 'Lincoln', 'Latitude': 40.8201966, 'Longitude': -96.7004763 },
  { 'state': 'Nevada', 'name': 'Carson City', 'Latitude': 39.1637984, 'Longitude': -119.7674034 },
  { 'state': 'New Hampshire', 'name': 'Concord', 'Latitude': 43.2081366, 'Longitude': -71.5375718 },
  { 'state': 'New Jersey', 'name': 'Trenton', 'Latitude': 40.2205824, 'Longitude': -74.759717 },
  { 'state': 'New Mexico', 'name': 'Santa Fe', 'Latitude': 35.6869752, 'Longitude': -105.937799 },
  { 'state': 'North Carolina', 'name': 'Raleigh', 'Latitude': 35.7795897, 'Longitude': -78.6381787 },
  { 'state': 'North Dakota', 'name': 'Bismarck', 'Latitude': 46.8083268, 'Longitude': -100.7837392 },
  { 'state': 'New York', 'name': 'Albany', 'Latitude': 42.6525793, 'Longitude': -73.7562317 },
  { 'state': 'Ohio', 'name': 'Columbus', 'Latitude': 39.9611755, 'Longitude': -82.9987942 },
  { 'state': 'Oklahoma', 'name': 'Oklahoma City', 'Latitude': 35.4675602, 'Longitude': -97.5164276 },
  { 'state': 'Oregon', 'name': 'Salem', 'Latitude': 44.9428975, 'Longitude': -123.0350963 },
  { 'state': 'Pennsylvania', 'name': 'Harrisburg', 'Latitude': 40.2731911, 'Longitude': -76.8867008 },
  { 'state': 'Rhode Island', 'name': 'Providence', 'Latitude': 41.8239891, 'Longitude': -71.4128343 },
  { 'state': 'South Carolina', 'name': 'Columbia', 'Latitude': 34.0007104, 'Longitude': -81.0348144 },
  { 'state': 'South Dakota', 'name': 'Pierre', 'Latitude': 44.3667876, 'Longitude': -100.3537522 },
  { 'state': 'Tennessee', 'name': 'Nashville', 'Latitude': 36.1626638, 'Longitude': -86.7816016 },
  { 'state': 'Texas', 'name': 'Austin', 'Latitude': 30.267153, 'Longitude': -97.7430608 },
  { 'state': 'Utah', 'name': 'Salt Lake City', 'Latitude': 40.7607793, 'Longitude': -111.8910474 },
  { 'state': 'Vermont', 'name': 'Montpelier', 'Latitude': 44.2600593, 'Longitude': -72.5753869 },
  { 'state': 'Virginia', 'name': 'Richmond', 'Latitude': 37.5407246, 'Longitude': -77.4360481 },
  { 'state': 'Washington', 'name': 'Olympia', 'Latitude': 47.0378741, 'Longitude': -122.9006951 },
  { 'state': 'West Virginia', 'name': 'Charleston', 'Latitude': 38.3498195, 'Longitude': -81.6326234 },
  { 'state': 'Wisconsin', 'name': 'Madison', 'Latitude': 43.0730517, 'Longitude': -89.4012302 },
  { 'state': 'Wyoming', 'name': 'Cheyenne', 'Latitude': 41.1399814, 'Longitude': -104.8202462 },
];

export const abbreviations = {
  'Alabama' : 'AL',
  'Alaska' : 'AK',
  'America Samoa' : 'AS',
  'Arizona' : 'AZ',
  'Arkansas' : 'AR',
  'California' : 'CA',
  'Colorado' : 'CO',
  'Connecticut' : 'CT',
  'Delaware' : 'DE',
  'District of Columbia' : 'DC',
  'Micronesia' : 'FM',
  'Florida' : 'FL',
  'Georgia' : 'GA',
  'Guam' : 'GU',
  'Hawaii' : 'HI',
  'Idaho' : 'ID',
  'Illinois' : 'IL',
  'Indiana' : 'IN',
  'Iowa' : 'IA',
  'Kansas' : 'KS',
  'Kentucky' : 'KY',
  'Louisiana' : 'LA',
  'Maine' : 'ME',
  'Marshall Islands' : 'MH',
  'Maryland' : 'MD',
  'Massachusetts' : 'MA',
  'Michigan' : 'MI',
  'Minnesota' : 'MN',
  'Mississippi' : 'MS',
  'Missouri' : 'MO',
  'Montana' : 'MT',
  'Nebraska' : 'NE',
  'Nevada' : 'NV',
  'New Hampshire' : 'NH',
  'New Jersey' : 'NJ',
  'New Mexico' : 'NM',
  'New York' : 'NY',
  'North Carolina' : 'NC',
  'North Dakota' : 'ND',
  'Ohio' : 'OH',
  'Oklahoma' : 'OK',
  'Oregon' : 'OR',
  'Palau' : 'PW',
  'Pennsylvania' : 'PA',
  'Puerto Rico' : 'PR',
  'Rhode Island' : 'RI',
  'South Carolina' : 'SC',
  'South Dakota' : 'SD',
  'Tennessee' : 'TN',
  'Texas' : 'TX',
  'Utah' : 'UT',
  'Vermont' : 'VT',
  'Virgin Island' : 'VI',
  'Virginia' : 'VA',
  'Washington' : 'WA',
  'West Virginia' : 'WV',
  'Wisconsin' : 'WI',
  'Wyoming' : 'WY',
};
